<template>
    <div class="services">
        <div class="container">
            <div class="row services1">
                <div class="col-12 col-md-6 service">
                    <div class="circle">
                        <h2>{{services.title}}</h2>
                    </div>
                    <p class="pt-3">{{services.content}}</p>
                </div>
                <div class="col-12 col-md-6 service1">
                    <div class="row">
                        <div v-for="social in socials" :key="social" class="col-12 col-lg-6 d-inline social">
                            <img :src="social.icon">
                            <h4>{{social.title}}</h4>
                            <p>{{social.content}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props :{
            services : Object,
            socials : Object
        }
    }
</script>

<style scoped>
    .services{
        color: #ffff;
    }
    .services p{
        color: #a4a4a4;
        font-size: .9rem;
    }
    .service1 h4{
        font-size: 1.2rem;
    }
    .social{
        background: #2F2F2F;
        border-radius: 10px;
    }
    .social p{
        font-size: .8rem;
     }
    
    /* Large Desktop */
    @media(min-width: 1200px){
         .services{
            padding: unset;
            margin: 0 auto;
        }
        .services1{
            margin: 0 auto;
        }
        .service{
            text-align: left;
            width: 27rem;
            margin: unset;
        }
        .service1{
            text-align: center;
            margin-left: 100px;
        }
        .social{
            margin: 10px 10px;
            width: 17rem;
            padding: 10px;
        }
        .social h4{
            padding: 10px 0;
        }
    }
    /* Medium Desktop */
    @media(min-width : 1025px) and (max-width: 1199px){
         .services{
            padding: unset;
            margin: 0 auto;
        }
        .services1{
            margin: 0 auto;
        }
        .service{
            text-align: left;
            width: 25rem;
            margin: unset;
        }
        .service1{
            padding: 0 30px;
            text-align: center;
            margin: unset;
        }
        .social{
            margin: 10px 10px;
            width: 12rem;
            padding: 10px;
        }
        .social h4{
            padding: 10px 0;
        }
    }
    /* Desktop */
    @media(min-width: 992px) and (max-width:1024px){
         .services{
            padding: auto 10px;
        }
        .service{
            text-align: left;
            width: 25rem;
            margin: auto;
        }
        .service1{
            padding: unset;
            text-align: center;
            margin: 30px auto;
        }
        .social{
            margin: 10px 10px;
            width: 14rem;
            padding: 10px;
        }
        .social h4{
            padding: 10px 0;
        }
    }
    /* Tablet */
    @media(min-width: 768px) and (max-width: 991px){
        .services{
            padding: auto 10px;
        }
        .service{
            text-align: center;
            width: 30rem;
            margin: auto;
        }
        .service1{
            padding: 0 30px;
            text-align: center;
            margin: 50px auto;
        }
        .social{
            margin: 10px auto;
            width: 22rem;
            padding: 10px;
        }
        .social h4{
            padding: 10px 0;
        }
    }
    /* Handphone */
    @media(max-width: 767px){
        .services{
            padding: unset;
        }
        .service{
            text-align: center;
            width: unset;
        }
        .service1{
            padding: 0 30px;
            text-align: center;
            margin-top: 50px;
        }
        .social{
            margin: 10px auto;
            width: 22rem;
            padding: 10px;
        }
        .social h4{
            padding: 10px 0;
        }
    }
</style>